import { useContext, useMemo } from "react";
import { AccessLevels, Pages } from "../assets/data/permissions";
import { Store } from "../context/store";

export const useAllPermissions = () => {
  const [loggedInUser] = useContext(Store)?.loggedInUser;

  return useMemo(() => {
    const perms = {};

    Object.keys(Pages).forEach((pageKey) => {
      AccessLevels.forEach((access) => {
        const varName =
          "can" +
          access.charAt(0).toUpperCase() +
          access.slice(1) +
          pageKey.charAt(0).toUpperCase() +
          pageKey.slice(1);

        perms[varName] =
          !!loggedInUser?.role?.permissions?.[pageKey]?.[access] || false;
      });
    });

    return perms;
  }, [loggedInUser]);
};
